import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import useIsLoading from "../../../hooks/useIsLoading";
import { hasPoolPro } from "../../talents/helpers";
import { TalentLink } from "../editOrder/long/talentsStatus/TalentLink";
import { CandidateGroupItem } from "../types/editOrder";

type Props = {
  selectedTalents: CandidateGroupItem[];
};

const ChooseForIntroductionDialogContent = ({ selectedTalents }: Props) => {
  const { t } = useTranslation("order");
  const isLoading = useIsLoading(["talentsStatus"]);

  const eligibleTalents = selectedTalents.filter((t) => !hasPoolPro(t));
  const poolProTalents = selectedTalents.filter((t) => hasPoolPro(t));

  const contentText =
    eligibleTalents.length > 1
      ? t("candidatesToIntroducePlural")
      : t("candidatesToIntroduceSingular");

  return (
    <Box>
      <Box>{contentText}</Box>
      <OverlaySpinner isLoading={isLoading} />
      <List>
        {eligibleTalents.map((talent) => (
          <ListItem key={talent.id} disablePadding>
            <ListItemText
              primary={
                <TalentLink id={talent.id} name={talent.fullName} status={talent.status} openInNewTab />
              }
            />
          </ListItem>
        ))}
        {poolProTalents.map((talent) => (
          <ListItem key={talent.id} disablePadding sx={{ opacity: 0.4 }}>
            <ListItemText
              primary={
                <TalentLink id={talent.id} name={talent.fullName} status={talent.status} openInNewTab />
              }
            />
          </ListItem>
        ))}
      </List>
      {poolProTalents.length > 0 && (
        <Typography my={1} color="text.secondary" fontSize="14px">
          {t("poolProTalentsFilteredFromIntroduction")}
        </Typography>
      )}
    </Box>
  );
};

export default ChooseForIntroductionDialogContent;
